"use client";
import { cn } from "@/app/lib/utils/cn";
import { fadeUp, stagger } from "@/app/lib/utils/motionVariants";
import { motion } from "framer-motion";
import { useRef } from "react";
import ButtonGroup from "../ui/ButtonGroup";
import { getLanguageFromPathname, withLanguagePrefix } from "@/app/lib/i18n-routing";
import { usePathname } from "next/navigation";

export default function ProductBenefits({ data }: any) {
    const pathname = usePathname();
    const lang = getLanguageFromPathname(pathname);
    const ref = useRef(null);
    if (!data) return null;
    return (
         <section ref={ref} className="relative py-6 lg:py-8">
            <div className="absolute bottom-40 left-1/4 w-full md:w-[600px] h-96 bg-[#0ea5e940] rounded-full blur-3xl z-0"></div>
            <div className="container mx-auto relative z-1">
                {/* Top heading block */}
                <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-50px' }} variants={stagger} className="text-center">
                    {/* <motion.span variants={fadeUp} className="inline-flex common-section-pill mb-2">
                        {data?.text}
                    </motion.span> */}
                    <motion.h2 variants={fadeUp} className="section-title">
                        {/* {data?.title ? (
                            <>{data.title.split(data.titleHighlight ?? ' ')[0]} <span className="section-highlight-title">{data?.titleHighlight ?? ''}</span> {data.title.split(data.titleHighlight ?? ' ')[1] ?? ''}</>
                        ) : (
                            <>Complete <span className="section-highlight-title">Transparency</span>.<br />Total <span className="section-highlight-title">Control</span>.</>
                        )}
                         */}
                         {data?.title }
                    </motion.h2>
                    <motion.p variants={fadeUp} className="mt-3 section-description max-w-2xl mx-auto">
                       {data?.subtitle ?? "Empower your sales with real-time insights, transparent pricing, and interactive project layouts that build buyer confidence and drive faster decisions."}
                    </motion.p>
                </motion.div>

                {/* 3 flowing columns */}
                <div className="mx-auto mt-5 lg:mt-12 grid  gap-10 md:grid-cols-3 md:gap-8 mx-auto max-w-6xl">
                    {data.items.map((c:any, idx:any) => (
                        <motion.div
                            key={c.title}
                            initial={{ opacity: 0, y: 18 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.45, delay: idx * 0.08 }}
                            className="group relative"
                        >
                            <span
                                className={cn(
                                    "text-xs font-semibold uppercase tracking-[0.2em]",
                                    c.accent === "secondary" ? "text-secondary" : "text-primary",
                                )}
                            >
                                {c.text}
                            </span>
                            <h3 className="mt-3 text-base lg:text-2xl font-semibold text-white transition-transform duration-300 group-hover:-translate-y-0.5">
                                {c.title}
                            </h3>
                            <p className="lg:mt-3 text-sm leading-7 text-white/60">{c.description}</p>
                            <motion.span
                                initial={{ scaleX: 0 }}
                                whileInView={{ scaleX: 1 }}
                                viewport={{ once: true, amount: 0.6 }}
                                transition={{ duration: 0.7, delay: 0.2 + idx * 0.08, ease: "easeOut" }}
                                style={{ transformOrigin: "left" }}
                                className="mt-5 block h-px w-full bg-gradient-to-r from-primary via-secondary to-transparent transition-all duration-300 group-hover:from-primary group-hover:via-secondary group-hover:to-secondary/40"
                            />
                            {c.buttons && c.buttons.length > 0 && (
                             <motion.div variants={fadeUp} className="mt-5 lg:mt-10">
                                <ButtonGroup
                                containerClass="flex flex-col sm:flex-row gap-4 justify-center"
                                buttons={c.buttons.map((b: any, i: number) => ({
                                    title: b.title,
                                    url: b.url,
                                    target: b.target || "_self",
                                    variant: i === 0 ? "primary" : "secondary",
                                    content:
                                    i === 0 ? (
                                        <>
                                        {b.title}
                                        </>
                                    ) : (
                                        b.title
                                    ),
                                }))}
                                localizedPath={(p: string) => withLanguagePrefix(p, lang)}
                                />
                            </motion.div>
                            )}
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}